export interface ResolutionOutcomeDisplayItem {
  type_id: number;
  type_name: string;
  outcome_id: number;
  outcome_name: string;
  outcome_key: string;
  colour: string;
  icon: string;
  type_sort_order: number;
  outcome_sort_order: number;
}

export function activeValue(value: any): boolean {
  return value == null || value === '' || value === 1 || value === '1' || value === true || value === 'Y' || value === 'y';
}

export function visibleValue(value: any): boolean {
  return value == null || value === '' || value === 1 || value === '1' || value === true || value === 'Y' || value === 'y';
}

export function numericSortValue(value: any, fallback: any): number {
  const numericValue = Number(value);
  if (!isNaN(numericValue) && numericValue > 0) {
    return numericValue;
  }
  const numericFallback = Number(fallback);
  return isNaN(numericFallback) ? 999999 : numericFallback;
}

export function sortResolutionOutcomeTypes(types: any[]): any[] {
  return Object(types || []).sort((a: any, b: any) => {
    const aSort = numericSortValue(a.sort_order, a.subject_service_resolution_outcome_type_id);
    const bSort = numericSortValue(b.sort_order, b.subject_service_resolution_outcome_type_id);
    return aSort - bSort || Number(a.subject_service_resolution_outcome_type_id || 0) - Number(b.subject_service_resolution_outcome_type_id || 0);
  });
}

export function sortResolutionOutcomes(outcomes: any[]): any[] {
  return Object(outcomes || []).sort((a: any, b: any) => {
    const aSort = numericSortValue(a.sort_order, a.id);
    const bSort = numericSortValue(b.sort_order, b.id);
    return aSort - bSort || Number(a.id || 0) - Number(b.id || 0);
  });
}

export function parseResolutionOutcomeAnswers(value: any): any[] {
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

export function buildResolutionOutcomeDisplay(attempt: any, outcomes: any[], types: any[]): ResolutionOutcomeDisplayItem[] {
  const answers = parseResolutionOutcomeAnswers(attempt && attempt.subject_service_resolution_outcome_type_answer_array);
  const displayItems: ResolutionOutcomeDisplayItem[] = [];

  if (answers.length) {
    answers.forEach((answer: any) => {
      const outcomeId = Number(answer.outcome_id);
      const typeId = Number(answer.type_id);
      const outcome = Object(outcomes || []).find((item: any) => Number(item.id) === outcomeId);
      const type = Object(types || []).find((item: any) => Number(item.subject_service_resolution_outcome_type_id) === typeId);

      displayItems.push({
        type_id: typeId,
        type_name: type ? type.subject_service_resolution_outcome_type_name : 'Resolution Outcome',
        outcome_id: outcomeId,
        outcome_name: outcome ? outcome.name : 'Outcome #' + outcomeId,
        outcome_key: outcome ? outcome.outcome : '',
        colour: outcome ? outcome.colour : (attempt ? attempt.subject_service_resolution_outcome_colour : ''),
        icon: outcome ? outcome.icon : 'fa fa-circle-thin',
        type_sort_order: type ? numericSortValue(type.sort_order, type.subject_service_resolution_outcome_type_id) : numericSortValue(null, typeId),
        outcome_sort_order: outcome ? numericSortValue(outcome.sort_order, outcome.id) : numericSortValue(null, outcomeId)
      });
    });
  }

  if (!displayItems.length && attempt && attempt.subject_service_resolution_outcome_id != null && Number(attempt.subject_service_resolution_outcome_id) >= 0) {
    const outcomeId = Number(attempt.subject_service_resolution_outcome_id);
    const outcome = Object(outcomes || []).find((item: any) => Number(item.id) === outcomeId);
    displayItems.push({
      type_id: 1,
      type_name: 'Primary',
      outcome_id: outcomeId,
      outcome_name: outcome ? outcome.name : attempt.subject_service_resolution_outcome_name,
      outcome_key: outcome ? outcome.outcome : '',
      colour: outcome ? outcome.colour : attempt.subject_service_resolution_outcome_colour,
      icon: outcome ? outcome.icon : 'fa fa-circle-thin',
      type_sort_order: 1,
      outcome_sort_order: outcome ? numericSortValue(outcome.sort_order, outcome.id) : numericSortValue(null, outcomeId)
    });
  }

  return displayItems.sort((a, b) => {
    return a.type_sort_order - b.type_sort_order || a.outcome_sort_order - b.outcome_sort_order || a.type_id - b.type_id || a.outcome_id - b.outcome_id;
  });
}
